import { render, staticRenderFns } from "./QCProductInfoDialog.vue?vue&type=template&id=4586a2f6&scoped=true&"
import script from "./QCProductInfoDialog.vue?vue&type=script&lang=js&"
export * from "./QCProductInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./QCProductInfoDialog.vue?vue&type=style&index=0&id=4586a2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586a2f6",
  null
  
)

export default component.exports